import { SET_SETTINGS } from './types'

const initialState = {
  settings: {}
}

export function uiReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_SETTINGS: {
      return {
        ...state,
        settings: { ...state.settings, ...action.payload }
      }
    }

    default:
      return state
  }
}
